import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import './tableOfContents.css'
import {AutoSizer, List} from 'react-virtualized'
import { TableOfContentsItemContainer } from '.'
import classNames from "classnames"
import Header from '../Aside/Header'
import CircularProgress from 'material-ui/CircularProgress'

class TableOfContents extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        close: PropTypes.func.isRequired,
        tableOfContents: PropTypes.array,
        selected: PropTypes.func.isRequired,
        currentIndex: PropTypes.number.isRequired,
    }

    rowRenderer = ({ key, index, style}) => (
        <div
            key={key}
            style={style}
            className={classNames('table-of-contents-item', {'selected': this.props.selected(index)})}
        >
            { this.props.tableOfContents[index] ? (
                <TableOfContentsItemContainer
                    index={index}
                    {...this.props.tableOfContents[index]}
                />
            ) : <CircularProgress mode="indeterminate" size={40} thickness={5} /> }
        </div>
    )

    render() {
        const { close, tableOfContents, currentIndex, t } = this.props

        return (
            <div className="table-of-contents">
                <Header
                    className='table-of-contents-header'
                    close={close}
                    title={t('visualizer:toolbar.left.tableOfContents.title')}
                />
                <AutoSizer disableWidth>
                    {({ height }) => (
                        <List
                            height={height}
                            width={350}
                            rowCount={tableOfContents.length}
                            rowHeight={44}
                            rowRenderer={this.rowRenderer}
                            scrollToIndex={currentIndex}
                        />
                    )}
                </AutoSizer>
            </div>

        )
    }
}

export default withTranslation()(TableOfContents)
